module.exports = __webpack_public_path__ + "static/media/circle-fresh-air.d8c6eebf.svg";